const styles = theme => ({
  timeline: {
    [theme.breakpoints.down('sm')]: {
      '&:before': {
        left: '5.3% !important'
      }
    },
    listStyle: 'none',
    marginBottom: '0px',
    padding: '0px',
    position: 'relative',
    '&:before': {
      top: '30px',
      bottom: '55px',
      position: 'absolute',
      content: '" "',
      width: '1px',
      backgroundColor: '#DBDBDB',
      left: '21px',
      marginLeft: '-1px'
    }
  },

  item: {
    marginBottom: '13px',
    position: 'relative',
    '&:before,&:after': {
      content: '" "',
      display: 'table'
    },
    '&:after': {
      clear: 'both'
    }
  },

  badge: {
    [theme.breakpoints.down('sm')]: {
      left: '5.3% !important'
    },
    color: '#FFFFFF',
    width: '39px',
    height: '39px',
    lineHeight: '44px',
    fontSize: '25px',
    fontFamily: 'arial',
    textAlign: 'center',
    position: 'absolute',
    top: '5px',
    zIndex: '100',
    borderTopRightRadius: '50%',
    borderTopLeftRadius: '50%',
    borderBottomRightRadius: '50%',
    borderBottomLeftRadius: '50%'
  },
  badgeIcon: {
    width: '21px',
    height: '21px',
    verticalAlign: 'baseline'
  },
  itemContent: {
    [theme.breakpoints.up('sm')]: {
      float: 'right',
      backgroundColor: '#FFFFFF',
      '&:before': {
        borderLeftWidth: '0',
        borderRightWidth: '15px',
        left: '-30px',
        right: 'auto'
      }
    },
    width: '605px',
    float: 'left',
    padding: '11px 20px 18px 17px',
    position: 'relative',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.14)',
    borderRadius: '6px',
    color: 'rgba(0, 0, 0, 0.87)',
    background: '#fff',
    '&:before': {
      position: 'absolute',
      top: '25px',
      right: '-15px',
      display: 'inline-block',
      content: '" "',
      width: '30px',
      height: '1px',
      background: '#DBDBDB'
    }
  },
  title: {
    fontSize: '14px',
    fontFamily: 'Google Sans',
    fontWeight: '500',
    color: '#212121'
  },
  date: {
    color: '#8B8B8B',
    fontSize: '12px',
    fontFamily: 'Google Sans',
    fontWeight: '300',
    marginLeft: '10px'
  },
  body: {
    fontSize: '13px',
    lineHeight: '16px',
    marginTop: '3px',
    fontFamily: 'Open Sans',
    color: '#424242',
    fontWeight: '300',
  },
  money: {
    color: '#000',
    fontWeight: 'bold',
    fontFamily: 'Open Sans',
    margin: '4px 0px 7px'
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/MaterialDashboardPro/Timeline/timelineStyle.js